import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";
import { heatPumpModelDtoSchema } from "@/types/backoffice/dto/heatpump/heatpump-model-dto.ts";

export const heatPumpDeclarationDtoSchema = z.object({
  id: branded.heatPumpDeclarationId,
  creationDatetime: z.string(),
  model: heatPumpModelDtoSchema,
  personId: branded.personId,
  siteId: branded.siteId,
});

export type THeatPumpDeclarationDto = z.infer<typeof heatPumpDeclarationDtoSchema>;
